export default  {
    state: {
        supplier_id: null,
        categories: [],
        errors: {},
        form: {
            code: '',
            company: '',
            dab: '',
            ein: '',
            opening_balance: '',
            address: '',
            city: '',
            state_id: '',
            zip: '',
            contact_person: '',
            phone: '',
            fax: '',
            email: '',
            note: '',
        },
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'company', label: 'Company', sortable: true},
                {key: 'dba', label: 'DBA', tdClass: 'text-muted'},
                {key: 'ein', label: 'EIN', tdClass: 'text-muted'},
                {key: 'opening_balance', label: 'Opening Balance', tdClass: 'text-muted'},
                {key: 'address', label: 'Address', tdClass: 'text-muted'},
                {key: 'city', label: 'City', tdClass: 'text-muted'},
                {key: 'state', label: 'State', tdClass: 'text-muted'},
                {key: 'zip', label: 'ZIP', tdClass: 'text-muted'},
                {key: 'contact_person', label: 'Contact Person', tdClass: 'text-muted'},
                {key: 'phone', label: 'Phone', tdClass: 'text-muted'},
                {key: 'fax', label: 'FAX', tdClass: 'text-muted'},
                {key: 'email', label: 'E-mail', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
    },

    getters: {
        getSupplierMeta: state => state.meta,

        getSupplierTableFields: state => state.table.fields,

        getSupplierForm: state => state.form,

        getSupplierErrors: state => state.errors,
    },

    mutations: {
        resetSuppliersMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setSuppliers: (state, payload) => {
            state.categories = payload;
        },

        setSuppliersMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setSupplierForm: state => {
            state.form = {
                code: '',
                company: '',
                dab: '',
                ein: '',
                opening_balance: '',
                address: '',
                city: '',
                state_id: '',
                zip: '',
                contact_person: '',
                phone: '',
                fax: '',
                email: '',
                note: '',
            };

            state.errors = {};
        },

        setSupplierErrors: (state, payload) => {
            state.errors = payload;
        },
    },

    actions: {
        fetchSuppliers: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const supplier = {
                "data": [
                    {
                        "supplier_id": 1,
                        "label": "Supplier1",
                        "data": {
                            "type": "Suppliers",
                            "attributes": {
                                "code": "PRU000001",
                                "company": "Demo Supplier",
                                "dba": "Demo Supplier",
                                "ein": "6789",
                                "opening_balance": "$10000",
                                "address": "",
                                "city": "",
                                "state": "",
                                "zip": "",
                                "contact_person": "Demo Contact",
                                "phone": "",
                                "fax": "",
                                "email": "",

                            }
                        },
                        "links": {"self": "supplier\/1"}
                    },
                    {
                        "supplier_id": 2,
                        "label": "Supplier2",
                        "data": {
                            "type": "Suppliers",
                            "attributes": {
                                "code": "PRU000002",
                                "company": "Demo Supplier",
                                "dba": "Demo Supplier",
                                "ein": "34256",
                                "opening_balance": "$1200000",
                                "address": "",
                                "city": "",
                                "state": "",
                                "zip": "",
                                "contact_person": "Demo Contact",
                                "phone": "",
                                "fax": "",
                                "email": "",

                            }
                        },
                        "links": {"self": "supplier\/2"}
                    },
                    {
                        "supplier_id": 3,
                        "label": "Supplier3",
                        "data": {
                            "type": "Suppliers",
                            "attributes": {
                                "code": "PRU000003",
                                "company": "Demo Supplier",
                                "dba": "Demo Supplier",
                                "ein": "234463",
                                "opening_balance": "$1000000",
                                "address": "",
                                "city": "",
                                "state": "",
                                "zip": "",
                                "contact_person": "Demo Contact",
                                "phone": "",
                                "fax": "",
                                "email": "",

                            }
                        },
                        "links": {"self": "supplier\/3"}
                    },
                ],
                "links": {
                    "self": "\/supplier",
                    "first": "http:\/\/pilot.test\/api\/inventory\/suppliers\/supplier?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/suppliers\/supplier?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/suppliers\/supplier?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/suppliers\/supplier",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setSuppliers', supplier);

                commit('setSuppliersMeta', supplier.meta);

                resolve(supplier);
            });
        },

        fetchEditSupplier: ({state, commit}, supplier_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + supplier_id + '/edit')
                    .then(response => {
                        state.supplier_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitSupplier: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setSupplierErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateSupplier: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.supplier_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setSupplierErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteSupplier: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.supplier_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
